import { render, staticRenderFns } from "./noAuthority.vue?vue&type=template&id=ebd2723a&scoped=true"
import script from "./noAuthority.vue?vue&type=script&lang=js"
export * from "./noAuthority.vue?vue&type=script&lang=js"
import style0 from "./noAuthority.vue?vue&type=style&index=0&id=ebd2723a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd2723a",
  null
  
)

export default component.exports